/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} In_Pre_InstallationInputs */



/**
* | output |
* | --- |
* | "Pre-installation" |
*
* @param {In_Pre_InstallationInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const in_pre_installation = /** @type {((inputs?: In_Pre_InstallationInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<In_Pre_InstallationInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Pre-installation")
	return /** @type {LocalizedString} */ ("En pré-installation")
});